import React from 'react';
import { usePaginationDisplayContext } from '../../context';
import { useLocationData } from '../../hooks';
import { Pages } from '../../types';
import { ReportEventForm } from '../ReportEventForm';
import { ReportEventIntro } from './ReportEventIntro';
import { ReportEventSuccess } from './ReportEventSuccess';

interface ReportEventContentProps {
    eventId: string;
    country: string;
    eventUrl: string;
    eventName: string;
    helpCenterLanguage: string;
}

export const ReportEventContent: React.FC<ReportEventContentProps> = (props) => {
    const { eventId, country, eventUrl, eventName, helpCenterLanguage } = props;
    const { page, setPage } = usePaginationDisplayContext();
    const userCountry = useLocationData();
    return (
        <>
            {page === Pages.intro && (
                <ReportEventIntro onClick={() => setPage?.(Pages.form)} />
            )}
            {page === Pages.form && (
                <ReportEventForm
                    eventId={eventId}
                    country={country}
                    eventName={eventName}
                    eventUrl={eventUrl}
                    helpCenterLanguage={helpCenterLanguage}
                    userCountry={userCountry}
                />
            )}
            {page === Pages.success && <ReportEventSuccess />}
        </>
    );
};
